import React, { FC, useState } from "react";
import PrivacyModal from "../modal/PrivacyModal";
import CaliforniaPrivacy from "../modal/CaliforniaPrivacy";
import TermsOfUse from "../modal/TermsOfUse";
import { Accessibility } from "lucide-react";
import AccessibilityModal from "../modal/Accessibility";

const Footer: FC = () => {
    const [modalState, setModalState] = useState({
        show: false,
        type: "",
    });

    const handleShowModal = (type: string) => {
        setModalState({
            show: true,
            type: type,
        });
    };

    const handleCloseModal = () => {
        setModalState({
            show: false,
            type: "",
        });
    };

    return (
        <div className="w-full bg-highlight-0 p-3  relative">
            <div className="footer_outer m-auto">
                <div className="flex justify-center items-center gap-4">
                    <ul className="block text-center sm:flex sm:items-center sm:justify-center sm:gap-4 text-text-0 mb-0">
                        <div className="sm:mt-0">
                            © {new Date().getFullYear()} TitleLogix Solutions, LLC
                        </div>
                    </ul>
                    <ul className="block text-center sm:flex sm:items-center sm:justify-center sm:gap-4 text-text-0 mb-0">
                        <h2
                            className="mb-0 cursor-pointer bottom_font underline"
                            onClick={() => handleShowModal("privacy")}
                        >
                            Privacy
                        </h2>
                    </ul>
                    <ul className="block text-center sm:flex sm:items-center sm:justify-center sm:gap-4 text-text-0 mb-0">
                        <h2
                            className="mb-0 cursor-pointer bottom_font underline"
                            onClick={() => handleShowModal("californiaPrivacy")}
                        >
                            California Privacy
                        </h2>
                    </ul>
                    <ul className="block text-center sm:flex sm:items-center sm:justify-center sm:gap-4 text-text-0 mb-0">
                        <h2
                            className="mb-0 cursor-pointer bottom_font underline"
                            onClick={() => handleShowModal("termsOfUse")}
                        >
                            Terms to Use
                        </h2>
                    </ul>
                    <ul className="block text-center sm:flex sm:items-center sm:justify-center sm:gap-4 text-text-0 mb-0">
                        <h2
                            className="mb-0 cursor-pointer bottom_font underline"
                            onClick={() => handleShowModal("accessibility")}
                        >
                            Accessibility
                        </h2>
                    </ul>
                </div>
            </div>

            {/* Modal */}
            {modalState.show && (
                <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-text-1 p-8 rounded-lg w-96">
                        <h2 className="text-xl font-bold mb-4">Modal Content</h2>
                        <p>
                            {modalState.type === "privacy" &&
                                <PrivacyModal
                                    show={true}
                                    setShow={handleCloseModal}

                                />
                            }
                            {modalState.type === "californiaPrivacy" &&
                                <CaliforniaPrivacy
                                    show={true}
                                    setShow={handleCloseModal}
                                />}
                            {modalState.type === "termsOfUse" &&
                                <TermsOfUse
                                    show={true}
                                    setShow={handleCloseModal}
                                />}
                            {modalState.type === "accessibility" && <AccessibilityModal
                                show={true}
                                setShow={handleCloseModal}
                            />}
                        </p>
                        <button
                            className="mt-4 py-2 px-4 bg-blue-500 text-text-0 rounded-full hover:bg-blue-600"
                            onClick={handleCloseModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Footer;
